import React from "react";
import cname from "../../style.module.scss";
import { TheMathImage } from "../../SpectrophotometerImages";
import { MathJax } from "better-react-mathjax";
import { PlainText as _PlainText } from "@learningblocks/storybook-components";
import { HighlightProvider as SharedHighlightProvider } from "@learningblocks/shared-components";
import { useHighlight } from "@learningblocks/shared/glossary";
const PlainText = _PlainText as React.FC<any>;
export const ContentTheMath = () => {
  const formula1 = "$A=log_{10}(I_0/I)$";
  const formula2 = "$A=log_{10}(100/10)=1.0$";
  const { onPlainTextClick } =
    React.useContext(SharedHighlightProvider.Context) || useHighlight();

  return (
    <div className={cname.content_math}>
      <div className={cname.content_math_image}>
        <TheMathImage />
      </div>
      <div className={cname.content_math_content}>
        <p>
          <div className={cname.content_math_content_heading}>
            The math: How does the spectrophotometer calculate the absorbance?
          </div>
          For those interested in math, absorbance A is expressed as a ratio of
          the light entering (
          <i>
            &nbsp;I<sub>0</sub>&nbsp;
          </i>
          ) and exiting (<i>&nbsp;I&nbsp;</i>) the sample in the cuvette:
        </p>
        <div className={cname.content_math_content_log}>
          <MathJax>{formula1}</MathJax>
        </div>
        <p>
          For example, if the entering light is measured as 100 and the exiting
          light as 10, then 90% of the light has been absorbed by the sample. In
          this case, the absorbance value is 1.0 and is calculated as follows:
        </p>
        <div className={cname.content_math_content_log}>
          <MathJax>{formula2}</MathJax>
        </div>
        <p>
          An absorbance of 0 at a particular wavelength means that no light has
          been absorbed by the solution. In other words, the intensities of the
          light entering (&nbsp;
          <i>
            I<sub>0</sub>
          </i>
          &nbsp;) and exiting (&nbsp;<i>I</i>&nbsp;) the solution are the same,
          so that (&nbsp;
          <i>
            I<sub>0</sub>&nbsp;/&nbsp;I
          </i>
          &nbsp;)&nbsp;=&nbsp;1&nbsp;and&nbsp;A&nbsp;=&nbsp;0.
        </p>
        <PlainText
          onClickHighlight={onPlainTextClick}
          text={`
                  <p>
                      Ideally, the absorbance of a sample measured by the
                      spectrophotometer should range from 0.1 to 1.0. Solutions
                      that have an absorbance value below 0.1 are too dilute, and
                      solutions with an absorbance value above 1.0 are too
                      concentrated. Solutions outside the ideal range produce a
                      higher error in the measurement and are outside the
                      <highlight contentId="recBjWgmq9qufTwKD">linear range</highlight>.
                  </p>`}
        />
      </div>
    </div>
  );
};
